import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// English translations
import en_common from './locales/en/common'
import en_auth from './locales/en/auth'
import en_home from './locales/en/home'
import en_invoices from './locales/en/invoices'
import en_maintenance from './locales/en/maintenance'
import en_parcels from './locales/en/parcels'
import en_vehicles from './locales/en/vehicles'
import en_rewards from './locales/en/rewards'
import en_external_parking from './locales/en/external_parking'
import en_lpr_events from './locales/en/lpr_events'
import en_win_pickup from './locales/en/win_pickup'
import en_meetings from './locales/en/meetings'
import en_my_data from './locales/en/my_data'

// Thai translations
import th_common from './locales/th/common'
import th_auth from './locales/th/auth'
import th_home from './locales/th/home'
import th_invoices from './locales/th/invoices'
import th_maintenance from './locales/th/maintenance'
import th_parcels from './locales/th/parcels'
import th_vehicles from './locales/th/vehicles'
import th_rewards from './locales/th/rewards'
import th_external_parking from './locales/th/external_parking'
import th_lpr_events from './locales/th/lpr_events'
import th_win_pickup from './locales/th/win_pickup'
import th_meetings from './locales/th/meetings'
import th_my_data from './locales/th/my_data'

const resources = {
  en: {
    common: en_common,
    auth: en_auth,
    home: en_home,
    invoices: en_invoices,
    maintenance: en_maintenance,
    parcels: en_parcels,
    vehicles: en_vehicles,
    rewards: en_rewards,
    external_parking: en_external_parking,
    lpr_events: en_lpr_events,
    win_pickup: en_win_pickup,
    meetings: en_meetings,
    my_data: en_my_data,
  },
  th: {
    common: th_common,
    auth: th_auth,
    home: th_home,
    invoices: th_invoices,
    maintenance: th_maintenance,
    parcels: th_parcels,
    vehicles: th_vehicles,
    rewards: th_rewards,
    external_parking: th_external_parking,
    lpr_events: th_lpr_events,
    win_pickup: th_win_pickup,
    meetings: th_meetings,
    my_data: th_my_data,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('liff_language') || 'th',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
